import { useState } from "react";
import _ from "lodash";
import { normalizePhoneForPhoneField } from "../utils/number";

export const useAccountForm = (numero: string) => {
  const normalizedNumero = normalizePhoneForPhoneField(numero);

  const [loading, setLoading] = useState(false);
  const [isPhoneIncorrect, setIsPhoneIncorrect] = useState(false);

  const [phone, setPhone] = useState(normalizedNumero);
  const [phoneObj, setPhoneObj] = useState({
    number: normalizedNumero.replace("+33", ""),
    countryCode: "FR",
    prefix: "+33",
  });

  const updatePhoneObj = (obj: any) => {
    setPhoneObj((prev: any) => {
      if (!_.isEqual(obj, prev)) {
        return {
          ...prev,
          ...obj,
          countryCode: obj.countryCode || prev.countryCode,
        };
      }
      return prev;
    });
  };

  return {
    loading,
    setLoading,
    isPhoneIncorrect,
    setIsPhoneIncorrect,
    phone,
    setPhone,
    phoneObj,
    updatePhoneObj,
  };
};
